import React from "react";
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { FastField, FormikProps } from "formik";
import SectionWrapper from "../../../../../common/pageSections/SectionWrapper";
import { Data as Receipt } from "../../../../../store/receipt/types";
import CustomizedRadio from "../../../../../common/formElements/RadioButton";
import MultipleSelect from "../../../../../common/formElements/MultipleSelectDropDown";
import SelectDropDown from "../../../../../common/formElements/SelectDropDown";
import TextInput from "../../../../../common/formElements/TextInput";

interface MerchantReceiptControlProps {
  heading: string;
  statusAttributeName: string;
  templateAttributeName: string;
  receipts?: Receipt[];
  isUpdateAllowed?: boolean;
  showHTMLReceipts: boolean;
}

const printOptions = [
  { value: "Always", label: "Always prints" },
  { value: "Never", label: "Never prints" },
  { value: "Prompt", label: "Prompt to print" },
];

const MerchantReceiptControl = (props: MerchantReceiptControlProps) => {
  const {
    heading,
    receipts,
    templateAttributeName,
    statusAttributeName,
    isUpdateAllowed,
    showHTMLReceipts,
  } = props;

  const textInputStyle = {
    marginTop: "8px",
  };

  if (!receipts || !receipts.length) {
    return (
      <SectionWrapper isChild={true} title={heading}>
        <Grid container spacing={2} xs={12}>
          <Grid item xs={12} md={6}>
            <FastField
              name={statusAttributeName}
              as={(props: FormikProps<Receipt>) => (
                <FormControl fullWidth>
                  <InputLabel shrink>Print Options</InputLabel>
                  <RadioGroup {...props} style={{ paddingTop: "1rem" }}>
                    {printOptions.map((option, index) => (
                      <CustomizedRadio
                        value={option.value}
                        label={option.label}
                        key={index}
                        disabled={!isUpdateAllowed}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            {showHTMLReceipts && (
              <Box pt={3}>
                <Typography align="center">No receipts to show</Typography>
              </Box>
            )}
          </Grid>
        </Grid>
      </SectionWrapper>
    );
  }
  return (
    <SectionWrapper isChild={true} title={heading}>
      <Grid container spacing={2} xs={12}>
        <Grid item xs={12} md={6}>
          <FastField
            name={statusAttributeName}
            as={(props: FormikProps<Receipt>) => (
              <FormControl fullWidth>
                <InputLabel shrink>Print Options</InputLabel>
                <RadioGroup {...props} style={{ paddingTop: "1rem" }}>
                  {printOptions.map((option, index) => (
                    <CustomizedRadio
                      value={option.value}
                      label={option.label}
                      key={index}
                      disabled={!isUpdateAllowed}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          {showHTMLReceipts ? (
            <MultipleSelect
              multiple={true}
              fieldname={templateAttributeName}
              label="Receipt Template"
              options={receipts.map((r) => r.attributes.Name)}
              disabled={!isUpdateAllowed}
            />
          ) : (
            <SelectDropDown
              fieldname={templateAttributeName}
              label="Receipt Template"
              options={receipts.map((r) => r.attributes.Name)}
              disabled={!isUpdateAllowed}
            />
          )}
          <TextInput
            style={textInputStyle}
            label="Merchant Receipt Display Name"
            fieldname="attributes.MerchantReceiptDisplayName"
          />
        </Grid>
      </Grid>
    </SectionWrapper>
  );
};

export default MerchantReceiptControl;
